import { Box, chakra, Flex, Text } from '@chakra-ui/react'
import { ComponentProps } from '@/baseComponents'

export interface FactCardProps extends ComponentProps {
  title: string
  subTitle?: string
  cardBackgroundColor?: string
  value?: string
}

/**
 * Represents a Fact card component.
 * @param title - The title of the fact card.
 * @param subTitle - The subtitle of the fact card.
 * @param backgroundColor - The background color of the fact card.
 * @param value - The value to be displayed at the bottom of the fact card.
 * @returns A FactCard component.
 */
export default chakra(FactCard)
function FactCard({
  title,
  subTitle,
  cardBackgroundColor = 'brand.aubergine',
  value,
  theme = 'brand',
  ...props
}: FactCardProps) {
  return (
    <Box
      backgroundColor={cardBackgroundColor}
      width={{ base: '18rem', sm: '20rem', md: '22rem' }}
      height={{ base: '18rem', sm: '20rem', md: '22rem' }}
      padding={'2.5rem'}
      borderRadius={'0.75rem'}
      display='flex'
      flexDirection={'column'}
      justifyContent={'space-between'}
      {...props}
    >
      {title && (
        <Flex
          flexDirection={'column'}
          color='white'
          gap={'0.5rem'}
          width='100%'
        >
          <Text fontSize={{ base: '1.5rem', lg: '1.75rem' }}>{title}</Text>
          {subTitle && (
            <Text
              fontSize={{ base: '0.75rem', lg: '1rem' }}
              fontStyle={'italic'}
              fontWeight={'315'}
            >
              {subTitle}
            </Text>
          )}
        </Flex>
      )}
      {value && (
        <Text
          color='white'
          fontSize={{ base: '2.5rem', sm: '3rem', md: '3rem' }}
          textAlign={'right'}
          width='100%'
        >
          {value}
        </Text>
      )}
    </Box>
  )
}
